import {
  addTicketApi,
  queryTicketApi,
  getTicketByIdApi,
  updateTicketApi,
  setTicketCancelOrHideApi,
  createWechatCardTicketApi,
  queryExportRecordApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  添加优惠券
  async addTicketAction(context, param) {
    const res = await addTicketApi(param)
    return res
  },
  //  查询优惠券列表
  async queryTicketAction(context, param) {
    const res = await queryTicketApi(param)
    return res
  },
  //  根据优惠券id查询优惠券
  async getTicketByIdAction(context, param) {
    const res = await getTicketByIdApi(param)
    return res
  },
  //  修改优惠券信息
  async updateTicketAction(context, param) {
    const res = await updateTicketApi(param)
    return res
  },
  //  作废电子券
  async setTicketCancelOrHideAction(context, param) {
    const res = await setTicketCancelOrHideApi(param)
    return res
  },
  //  同步微信卡券
  async createWechatCardTicketAction(context, param) {
    const res = await createWechatCardTicketApi(param)
    return res
  },
  // 查询导出电子券信息同步微信卡券
  async queryExportRecordAction(context, param) {
    const res = await queryExportRecordApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
